import React, { useState, useEffect } from 'react';
import VesselModal from "./VesselModal";
import { motion } from 'framer-motion';
import {
    Search, Plus, FileText,
    Ship,
} from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { getVesselList,createVessel,UpdateVessel,DeleteVessel } from '@/redux/Masters/vessel/actions';
import { callLoader } from '@/redux/Loader/actions';
import { validateForm } from "../../components/ui/useFormValidation";
import { showToast } from '@/redux/Toast/actions';
import { useDebounced } from '@/hooks/useDebounced';
import { getVesselColumns, initialVesselForm } from './helper';
import { DataTable } from '@/components/ui/table';
import Pagination from '../PortPlace/Pagination';
import Swal from 'sweetalert2';


const MaintainVessels = () => {
    const [currentPage, setCurrentPage] = useState(1);
   const [openModal, setOpenModal] = useState(false);
   const [selectedVessel, setSelectedVessel] = useState(null);
   const dispatch = useDispatch();
    const authUser = JSON.parse(localStorage.getItem('authUser'))?.[0];

 
        

   const [dateErrors, setDateErrors] = useState({});
  // TEMP (replace with real ones later)
  const [formData, setFormData] = useState(initialVesselForm);
  const [errors, setErrors] = useState({});

  const [searchText, setSearchText] = useState('');
  const [recordsPerPage, setRecordsPerPage] = useState(10);
  const [selectedLetter, setSelectedLetter] = useState('A');

  const { vesselList, pagination } = useSelector(state => state.vessel  );

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: "" }));
  };

     const handleDateError = (fieldName, hasError) => {
        setDateErrors(prev => ({
            ...prev,
            [fieldName]: hasError
        }));
    };
    
       const handleDateChange = (name, value) => {
        setFormData((prev) => ({
            ...prev,
            [name]: value // YYYY-MM-DD
        }));
    };  

     useEffect(() => {
          _getList(1);
      }, [recordsPerPage,selectedLetter]); 

      const handlePrevious = () => {
        if (currentPage > 1) _getList(currentPage - 1);
    };

    const handleNext = () => {
        if (pagination?.nextPage > 0) _getList(pagination.nextPage);
    };
     const handleGoto = (page) => {
    _getList(page);
  };

      const _getList = async (page = 1) => {
       setCurrentPage(page);
       dispatch(callLoader(1)); // optional loader
  
      try {
          const payload = {
              pageNo: page,
              records: recordsPerPage,
              searchKeyward:searchText,
              // SearchText: searchText,
              SearchKey: selectedLetter,
              isIMO: false,
              filterType:'',            
              CompanyID:authUser?.companyId
          };
  
          await dispatch(getVesselList(payload));
      } catch (error) {
          console.error('Error fetching address book list:', error);
          // optional: show toast / alert
              dispatch(showToast("Error fetching address book list", "error"));
      } finally {
           dispatch(callLoader(0));
      }
  };

  
     const debouncedFetchList = useDebounced(_getList, 300);

     const handleSearch = (value) =>{
setSearchText(value);
debouncedFetchList(1);
      }

     const [items, setItems] = useState([]);
     const validationConfig = {
        vessel: { required: true, label: "Vessel Name" },

    };

    //-- Form Click Events

    const handleAddNew = () => {
      setFormData(initialVesselForm);
      setOpenModal(true);
     };


  // Save Handler
  const handleSaveVessel = async () => {
     
            const validationErrors = validateForm({
                data: formData,
                items,
                rules: validationConfig,
            });
            setErrors(validationErrors);
    
            if (Object.keys(validationErrors).length > 0) {
                return;
            }
            try {
                dispatch(callLoader(1));   
                const payload = {
                        ...formData,                                  
                };
                
                   if (Number(formData.vessID) === 0) 
                    {   
                        const addDetails = await createVessel(payload);
                        if (addDetails?.statuscode === 201 || addDetails?.statuscode === 200) {                          
                            //toast.success("Record Save successfully");
                                dispatch(showToast("Record Save successfully.", "success",true));
                        }
                         setTimeout(()=>{
                            setOpenModal(false);  
                         },500)                                                                      
                    }
                    else{                    
                        const addDetails = await UpdateVessel(payload);
                        if (addDetails?.statuscode === 201 || addDetails?.statuscode === 200) {                            
                           // toast.success("Record Update successfully");
                                dispatch(showToast("Record Update successfully", "success",true));
                                 setTimeout(()=>{
                            setOpenModal(false);  
                         },500)  
                        }
                     //   setOpenModal(false);  
                    }   
                _getList(currentPage); // refresh table
            } 
            catch (err) {
              //  toast.error("Failed to save vessel");
                    dispatch(showToast("Failed to save vessel", "error"));
            }
             finally {
                dispatch(callLoader(0));
            }
        };

   // Edit Detail
   const handleEdit = (row) => {
  setFormData({
            ...row,   
            createdBy: String(authUser.id),          
            modifyBy: String(authUser.id),
        });
  setOpenModal(true);        // 👈 open modal
};
   const handleDelete = async (payload) => {

        const result = await Swal.fire({
              title: "Are you sure?",
              text: "This record will be deleted.",
              icon: "warning",
              showCancelButton: true,
              confirmButtonText: "Yes, delete it",
              cancelButtonText: "Cancel",
              confirmButtonColor: "#d33",
              cancelButtonColor: "#3085d6",
            });
        
            if (!result.isConfirmed) return;
        
        const updateDetails = await DeleteVessel(payload);
        if (updateDetails?.statuscode === 201 || updateDetails?.statuscode === 200)
        {
            
                dispatch(showToast("Record delete successfully.", "success"));
            _getList(1);
        }
         _getList(1);
    };
const handlers = {
  handleEdit,
  handleDelete
};
    const columns = getVesselColumns(handlers);
  return (
    <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="min-h-screen bg-slate-50 dark:bg-slate-900 p-6"
        >
    <div className="h-full flex flex-col">
     
                        {/* Header */}
                  <div className="flex items-center justify-between mb-6">
                          <div className="flex items-center gap-3">
                            <div className="w-12 h-12 bg-cyan-100 dark:bg-cyan-900/30 rounded-xl flex items-center justify-center">
                              <Ship className="w-6 h-6 text-cyan-600 dark:text-cyan-400" />
                            </div>
                            <div>
                              <h1 className="text-2xl font-bold text-slate-900 dark:text-white">Vessel List</h1>
                          <p className="text-sm text-slate-500 dark:text-slate-400 mt-0.5">{pagination?.totalRecord} total vessels</p>
                            </div>
                          </div>
                          <button 
                             onClick={() => handleAddNew ()}
                            data-testid="add-clause-btn"
                            className="flex items-center gap-2 px-4 py-2.5 bg-cyan-600 hover:bg-cyan-700 text-white rounded-xl font-medium transition-colors"
                          >
                            <Plus className="w-4 h-4" />
                            Add New Vessel
                          </button>
                        </div>

                       <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 p-4 mb-6">
                          <div className="relative max-w-md">
                            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                            <input
                              type="text"
                              placeholder="Search by clause name, code, or category..."
                              value={searchText}
                                  onChange={(e) => handleSearch(e.target.value)}
                              className="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-700 border border-slate-200 dark:border-slate-600 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-cyan-500/20"
                            />
                          </div>
                          
                        </div>


                   <div className="bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 overflow-hidden">
                            <DataTable
                              data={vesselList || []}
                              columns={columns}
                              trClass="border-b border-slate-100 dark:border-slate-700/50 hover:bg-slate-50 dark:hover:bg-slate-700/30"
                              thClass="px-4 py-4 text-left text-xs font-semibold uppercase tracking-wider"
                              tdClass="px-4 py-4 text-sm text-slate-600 dark:text-slate-400"
                              htrClass="bg-gradient-to-r from-slate-700 to-slate-800 text-white"
                              isAplyingFilter={!!searchText}
                              resetFilters={() => {
                                setSearchText(''); 
                                setSelectedLetter('ALL'); 
                              }}
                              emptyText="No vessel found"
                            />
                          </div>
                  
                          {/* Pagination */}
                          {vesselList.length > 0 && (
                            <Pagination
                              currentPage={currentPage}
                              nextPage={pagination?.nextPage}
                              recordsPerPage={recordsPerPage}
                              setRecordsPerPage={setRecordsPerPage}
                              onPrevious={handlePrevious}
                              onNext={handleNext}
                                totalRecord={pagination?.totalRecord}
                                handleGoto={handleGoto}
                            />
                          )}

 
    </div>
      {/* ✅ Modal (CORRECT PLACE) */}
      <VesselModal
        open={openModal}
        onClose={() => {setOpenModal(false); setSelectedVessel(null); setFormData(initialVesselForm);}}
        formData={formData}
        errors={errors}
        handleInputChange={handleInputChange}
        handleDateError={handleDateError}
        handleDateChange={handleDateChange}
        onSave={handleSaveVessel}
        editData={selectedVessel}
      />
     </motion.div>   
  );
};

export default MaintainVessels;
